import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

type UserContextValue = {
  userId: number | null;
  setUserId: (id: number | null) => void;
  hydrated: boolean; // żeby UI mogło poczekać aż wczytasz storage
};

const UserContext = createContext<UserContextValue | null>(null);

const STORAGE_KEY = 'app:employeeKioskSelectedUser';

export function UserProvider({ children }: { children: React.ReactNode }) {
  const [userId, setUserIdState] = useState<number | null>(null);
  const [hydrated, setHydrated] = useState(false);

  // rehydratacja po mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && stored !== '' && stored !== null) {
        const parsed = Number(stored);
        if (Number.isFinite(parsed)) setUserIdState(parsed);
        else {
          setUserIdState(null);
          localStorage.removeItem(STORAGE_KEY); // opcjonalnie
        }
      }
    } finally {
      setHydrated(true);
    }
  }, []);

  // setter, który zapisuje też do storage
  const setUserId = (id: number | null) => {
    setUserIdState(id);
    if (id !== null) localStorage.setItem(STORAGE_KEY, `${id}`);
    else localStorage.removeItem(STORAGE_KEY);
  };

  const value = useMemo(
    () => ({ userId, setUserId, hydrated }),
    [userId, hydrated]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used within UserProvider');
  return ctx;
}
